import React, {  useContext, useEffect } from "react";
import RbdGenericList from "./RbdGenericList";
import PageBody from "../GeneralComponents/PageBody";
import GeneralContext from "../GeneralContext/GeneralContext";

import Grid from "@mui/material/Grid2";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import { useNavigate } from 'react-router-dom';
import {ROL_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL} from "../../Constants/Constants";

import axios from "../../api/axios";

export default function ParqueList() {
  const { includeRol, pageTitle, setPageTitle, userSesion } = useContext(GeneralContext);
  const navigate = useNavigate();


  
  useEffect(() => {
        void axios.getAdminHealth().catch(() => {});
    }, []);

  return (
    <PageBody>

      {includeRol([ROL_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL]) ? (<Grid container spacing={2} columns={10} justifyContent="flex-end" sx={{ pt: 1, mb: "4rem" }}>
            <Grid item size={{ xs: 10, sm: 5, md: 2 }}>
              <PageButtonBlack onClick={() => navigate('/agregar_rbd')} width="100%" pad="24px 16px">
                Agregar RBD
              </PageButtonBlack>
            </Grid>
            <Grid item size={{ xs: 10, sm: 5, md: 2 }}>
              <PageButtonBlack onClick={() => navigate('/parque_recepcion')} width="100%" pad="24px 16px">
                Recepción de Obras
              </PageButtonBlack>
            </Grid>
            <Grid item size={{ xs: 10, sm: 5, md: 2 }}>
              <PageButtonBlack onClick={() => navigate('/parque_inicio')} width="100%" pad="24px 16px">
                Inicio de Servicio
              </PageButtonBlack>
            </Grid>
            <Grid item size={{ xs: 10, sm: 5, md: 2 }}>
              <PageButtonBlack onClick={() => navigate('/parque_baja')} width="100%" pad="24px 16px">
                Bajas
              </PageButtonBlack>     
            </Grid>
            <Grid item size={{ xs: 10, sm: 5, md: 2 }}>
              <PageButtonBlack onClick={() => navigate('/parque_tecnologia')} width="100%" pad="24px 16px">
                Cambio de Tecnología
              </PageButtonBlack>     
            </Grid>
          </Grid>) : null}

    <RbdGenericList
      pageTitleOverride="ESTADO DE PARQUE"
      columnOrder={[
        "checkbox",
        "rbd",
        "Nombre",
        "operador",
        "Fecha_recepcion",
        "Fecha_servicio",
        "Fecha_Baja",
        "estado_pago",
        "estado"
      ]}
      filtersConfig={[
        { item: "operador", name: "Operador" },
        { item: "Fecha_recepcion_periodo", name: "Periodo recepción de obras" },
        { item: "Fecha_servicio_periodo", name: "Periodo inicio de servicio" },
        { item: "Fecha_Baja_periodo", name: "Periodo baja" },
        { item: "estado_pago", name: "Estado pago" },
        { item: "estado", name: "Estado servicio" }
      ]}
    />

    </PageBody>
  );
}
